export default __webpack_public_path__ + "static/media/pumpkin-l3.e459a328.webp";